var checkoutURL = "https://stellar.centraqa.com/api/checkout";
var liveHosts = ["stellarequipment.se", "www.stellarequipment.com"];
var devQA = ["c6837.cloudnet.cloud"];
if (liveHosts.indexOf(window.location.hostname) !== -1) {
  checkoutURL = "https://stellar.centra.com/api/checkout";
}
if (devQA.indexOf(window.location.hostname) !== -1) {
  checkoutURL = "https://stellar-dev.centraqa.com/api/checkout";
}
export var checkoutAPI = checkoutURL;
export var paymentMethodsMap = {
  adyenDropIn: ["adyen_di", "adyen-test", "adyen-test-aud", "adyen", "adyen-aud", "adyen-cad", "adyen-chf", "adyen-dkk", "adyen-eur", "adyen-gbp", "adyen-jpy", "adyen-krw", "adyen-nok", "adyen-nzd", "adyen-sek", "adyen-usd"],
  klarnaCheckout: ["klarna-checkout", "klarna-payments-dk", "kco", "klarna"]
};
export { liveHosts };


// WEBPACK FOOTER //
// ./scripts/config.js